import React from 'react';

const BackButton = () => {
    const handleBackClick = () => {
        window.history.back();
    };
    
    return (
        <button className={"back-button"} onClick={handleBackClick}>Voltar</button>
    );
};

export default BackButton;
